import {
  Required,
  DataValidator,
  transformKeys,
  IsBoolean,
  IsNumber,
  IsString,
  ValidateNested,
} from "@/utils/type-vaildator";
import api from "./api";

export interface KnowledgeAddAgentUserKnowledgeFolderResponse {
  message: string;
};


class KnowledgeAddAgentUserKnowledgeFolderData {
  @IsString("Folder name must be a string")
  message: string;
}

const transformAndValidateData = (
  response: KnowledgeAddAgentUserKnowledgeFolderResponse
): KnowledgeAddAgentUserKnowledgeFolderData => {
  const transformedData = transformKeys(response);

  try {
    return DataValidator.validateOrThrow(transformedData, KnowledgeAddAgentUserKnowledgeFolderData);
  } catch (error) {
    console.error("Knowledge add agent user knowledge folder data validation failed:", error.message);
    throw error;
  }
};

/** 创建智能体用户知识库 */
export const knowledgeAddAgentUserKnowledgeFolder = async ({
  agentId,
  userId,
  folderId,
  type
}: {
  agentId: string,
  userId: string,
  folderId: number[],
  type: number
}) => {
  const res = await api.post<KnowledgeAddAgentUserKnowledgeFolderResponse>('/knowledge/add_agent_user_knowledge_folders', {
    agent_id: agentId,
    user_id: userId,
    folder_id: folderId,
    type: type,
  });
  const data = transformAndValidateData(res.data);
  return data;
}